import { gql } from 'graphql-request'

export default gql`
  query getMedicalEquipmentApprovedGroup($provider: String) {
    applications {
      medicalEquipment {
        approvedGroup(provider: $provider) {
          success
          items {
            hRegistroEnderecoEquipamento
            endereco
            enderecoNumero
            equipamento
            marca
            modelo
            numeroSerie
            ano
          }
        }
      }
    }
  }
`
